import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home.js";
import Dashboard from "./Pages/Dashboard";
import TestimonialAdd from "./Pages/TestimonialAdd";
import FaqAdd from "./Pages/FaqAdd";
import ManageBlog from "./Pages/ManageBlog";
import PrivateRoutes from "./PrivateRoute";
import Images from "./Pages/Images.js";
import Certificate from "./Pages/Certificate.js";
import AddBlog from "./Pages/AddBlog";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route element={<PrivateRoutes />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/addBlog" element={<AddBlog />} />
          <Route path="/dashboard/manageBlogs" element={<ManageBlog />} />
          <Route
            path="/dashboard/addTestimonial"
            element={<TestimonialAdd />}
          />
          <Route path="/dashboard/Certificate" element={<Certificate />} />
          <Route path="/dashboard/addFAQ" element={<FaqAdd />} />
          <Route path="/dashboard/images" element={<Images />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
